import { Experiment } from '@ms/yammer-data/dist/state/types';
import { AnalyticsEventName, reportUsage } from '@ms/yammer-data/dist/telemetry';
import { useShouldUseExperimentTreatment } from '@ms/yammer-hooks/dist/experiments';
import { useIsViewerCommunitiesCountGreaterThanEqualTo } from '@ms/yammer-hooks/dist/viewerCommunityIdSets';
import VivaEngageCollapsiblePanel from '@ms/yammer-web-components/dist/teams/VivaEngageCollapsiblePanel';
import { PageLayoutWidth } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import React, { ReactNode, useCallback } from 'react';

import { useShouldDisplayCollapsiblePanelForCurrentPage } from './useShouldDisplayCollapsiblePanelForCurrentPage';

type UseCollapsiblePanelCallback = () => (width: PageLayoutWidth | undefined) => ReactNode;
export const useCollapsiblePanelCallback: UseCollapsiblePanelCallback = () => {
  const shouldDisplayCollapsiblePanel = useShouldDisplayCollapsiblePanelForCurrentPage();
  const vivaEngageUXChangeTreatmentCondition = useIsViewerCommunitiesCountGreaterThanEqualTo(3);
  const shouldInitiallyExpandQuickNav = useShouldUseExperimentTreatment({
    experiment: Experiment.VivaEngageRightUXChangeV2,
    treatments: ['treatmenta', 'treatmentb', 'treatmentc'],
    condition: vivaEngageUXChangeTreatmentCondition,
    reportExperiment: false,
  });

  /* istanbul ignore next */
  const reportCollapsiblePanelExpanded = useCallback(() => {
    reportUsage({
      eventName: AnalyticsEventName.RightPanelExpanded,
    });
  }, []);

  return useCallback(
    (width) => {
      if (!shouldDisplayCollapsiblePanel || !width || width === PageLayoutWidth.Small) {
        return null;
      }

      return (
        <VivaEngageCollapsiblePanel
          isInitiallyCollapsed={!shouldInitiallyExpandQuickNav}
          onExpand={reportCollapsiblePanelExpanded}
        />
      );
    },
    [shouldDisplayCollapsiblePanel, reportCollapsiblePanelExpanded, shouldInitiallyExpandQuickNav]
  );
};
